function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group 2");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "SG",
  transform: "translate(-91.000000, -167.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(74.000000, 151.000000)"
}, React.createElement("g", {
  id: "Group-2",
  transform: "translate(17.000000, 16.000000)"
}, React.createElement("path", {
  d: "M7.77711561,0 L11.7493047,19.4778911 L16.3484307,0 L24,0 L18.0627731,21.8350291 C17.4775526,24.0077861 16.7806913,25.5388821 15.9721891,26.4287036 C15.0242352,27.475848 13.6448153,28 11.8327374,28 C10.0766786,28 8.73857767,27.5813742 7.81883194,26.7429629 C6.81565356,25.827243 6.03496226,24.269089 5.47755264,22.0708202 L0,0 L7.77711561,0 Z",
  id: "Fill-1"
}), React.createElement("polygon", {
  id: "Fill-3",
  points: "25 28 32 28 32 0 25 0"
}), React.createElement("path", {
  d: "M53.7727978,0 L53.7727978,6.47097309 L45.4373955,6.47097309 C44.2312529,6.47097309 43.5849136,6.85700647 43.4983777,7.62907324 C43.556196,7.94867115 43.7139518,8.27495191 43.9727938,8.60791554 C44.2312529,8.94048605 44.611475,9.2282421 45.0927833,9.50617041 C48.6614337,11.571567 51.3409847,13.3248347 52.716753,14.7392421 C54.2418532,16.3069622 55,18.0539402 55,19.9715277 C55,20.7176492 54.9134641,21.5156612 54.7415409,22.3687085 C54.282058,24.1263004 53.2336712,25.5033625 51.5963806,26.5022534 C49.9594728,27.5011442 47.718728,28 44.8752947,28 L36.3017271,28 L36.3017271,21.52942 L44.5808428,21.52942 C45.6150622,21.52942 46.3904395,21.3898662 46.9077407,21.1099723 C47.424276,20.8304716 47.6827351,20.4770663 47.6827351,20.0509357 C47.6827351,19.412133 47.3672236,18.912491 46.7779368,18.4938296 C44.4085367,16.8089629 41.2090043,15.1838488 38.9295863,13.3814424 C36.8959916,11.7720527 36,9.74636023 36,7.5893692 L36.129421,6.15137518 C36.4453155,4.36705182 37.3861067,2.89603662 38.9514117,1.73754335 C40.5167167,0.579443189 42.3906411,0 44.5739505,0 L53.7727978,0 Z",
  id: "Fill-5"
}), React.createElement("path", {
  d: "M75,28 L68.6943955,28 C65.5092168,28 63.1725259,27.0548457 61.6843228,25.1645371 C60.561565,23.7263613 60,21.9154708 60,19.7326519 L60,0 L66.8146972,0 L66.8146972,18.1741695 C66.8146972,19.372125 67.0104448,20.1576568 67.4019401,20.5307647 C67.92443,21.0363672 68.9950877,21.2895616 70.6135411,21.2895616 L75,21.2895616 L75,28 Z",
  id: "Fill-6"
}), React.createElement("polygon", {
  id: "Fill-7",
  points: "77 28 84 28 84 0 77 0"
}), React.createElement("path", {
  d: "M101.80339,0 L88,0 L88,28 L95.3244892,28 L95.3244892,6.34786148 L100.211556,6.34786148 C102.237814,6.34786148 103.895876,7.93453208 103.895876,9.87453854 L103.895876,28 L111,28 L111,9.02834042 C111,4.06237981 106.862334,0 101.80339,0",
  id: "Fill-8"
}), React.createElement("path", {
  d: "M125.659692,5.74130136 L124.97118,5.74130136 C123.398342,5.74130136 122.11212,7.16021231 122.11212,8.8944368 L122.11212,10.6754472 L128.070667,10.6754472 L131,16.6660114 L122.11212,16.6660114 L122.11212,18.4466287 C122.11212,20.1812463 123.398342,21.6001573 124.97118,21.6001573 L130.983024,21.6001573 L130.983024,28 L123.24319,28 C118.70983,28 115,24.3982701 115,19.9944958 L115,7.99685473 C115,3.72046393 118.499408,0.19933163 122.853533,0 L125.659692,5.74130136 Z",
  id: "Fill-9"
})))));

var SvgVisline = function SvgVisline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "86px",
    height: "18px",
    viewBox: "0 0 131 28",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVisline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visline.5a38d478.svg";
export { ForwardRef as ReactComponent };